import koLang from './entries/ko_KR'
import enLang from './entries/en_US';

const AppLocale = {
    ko: koLang,
    en: enLang
};

export default AppLocale;